<template>
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-12">
                <div class='chart-row'>
                    <div id="volume-pie-chart" class='chart-column'></div>
                    <div id="spend-pie-chart" class='chart-column'></div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'activeTab',
        ],
        computed: {
            totalRow() {
                return {
                    'directApps': _.sumBy(this.data, item => Number(item.directApps)),
                    'conversionsApps': _.sumBy(this.data, item => Number(item.conversionsApps)),
                    'mcApps': _.sumBy(this.data, item => Number(item.mcApps)),
                    'calls': _.sumBy(this.data, item => Number(item.calls)),
                    'jobadviserApps': _.sumBy(this.data, item => Number(item.jobadviserApps)),
                    'driverengageApps': _.sumBy(this.data, item => Number(item.driverengageApps)),
                    'directAppsSpend': _.sumBy(this.data, item => Number(item.directAppsSpend)),
                    'conversionsSpend': _.sumBy(this.data, item => Number(item.conversionsSpend)),
                    'mcAppsSpend': _.sumBy(this.data, item => Number(item.mcAppsSpend)),
                    'callsSpend': _.sumBy(this.data, item => Number(item.callsSpend)),
                    'jobadviserSpend': _.sumBy(this.data, item => Number(item.jobadviserSpend)),
                    'driverengageSpend': _.sumBy(this.data, item => Number(item.driverengageSpend)),
                };
            },
        },
        watch: {
            data() {
                this.refresh();
            },
            activeTab() {
                if (this.activeTab == 'type') this.refresh();
            }
        },
        methods: {
            refresh() {
                this.drawVolumeChart();
                this.drawSpendChart();
            },
            drawVolumeChart() {
                var data = google.visualization.arrayToDataTable([
                    ['Type', 'Volume'],
                    ['Calls', this.totalRow.calls],
                    ['MC Leads', this.totalRow.mcApps],
                    ['Job Board Leads', this.totalRow.directApps],
                    ['Conversions', this.totalRow.conversionsApps],
                    ['Job Adviser', this.totalRow.jobadviserApps],
                    ['DriverEngage', this.totalRow.driverengageApps],
                ]);
                var options = {
                    title: 'Leads'
                };

                var chart = new google.visualization.PieChart(document.getElementById('volume-pie-chart'));
                chart.draw(data, options);
            },
            drawSpendChart() {
                var data = google.visualization.arrayToDataTable([
                    ['Type', 'Spend'],
                    ['Calls Spend', this.totalRow.callsSpend],
                    ['MC Leads Spend', this.totalRow.mcAppsSpend],
                    ['Job Board Leads Spend', this.totalRow.directAppsSpend],
                    ['Conversions Spend', this.totalRow.conversionsSpend],
                    ['Job Adviser Spend', this.totalRow.jobadviserSpend],
                    ['DriverEngage Spend', this.totalRow.driverengageSpend],
                ]);
                var options = {
                    title: 'Spend'
                };

                var chart = new google.visualization.PieChart(document.getElementById('spend-pie-chart'));
                chart.draw(data, options);
            },
        },
    }
</script>

<style scoped>
    .chart-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width: 100%;
    }
    .chart-column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        min-height: 40em;
    }    
</style>
